import React from "react";
import { Navigate } from "react-router-dom";
import { useTypedSelector } from "../../store";

interface ProtectedRouteProps {
  Element: React.FC;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  Element,
  redirectTo = "/login",
}) => {
  const adminSession = useTypedSelector((state) => state.session.accessToken);

  // if not online redirect to
  if (!adminSession) return <Navigate to={redirectTo} />;

  // If authenticated render the element
  return <Element />;
};

export default ProtectedRoute;
